import { useWeb3React } from '@web3-react/core';
import useSWR from 'swr';
import { useEffect } from 'react';
import {
    sleep,
    verifyChainConfig,
    // subgraphQuery
} from '../../../helpers';
import {
    // EnabledChains,
    Position,
    // , Trader
} from '../../../config/constants';
// import { formatUnits, parseUnits } from 'ethers/lib/utils';
// import { BigNumber } from 'ethers';
import useDelayLoading from '../../useDelayLoading';
import useTradePools from './useTradePools';
import { TradePair } from '../../../context/chart/chartTypes';
// import useTokenDetails from '../useTokenDetails';
// import { config } from '../../../config/config';

export type UserTrade = {
    id: string;
    action: Position['status'];
    margin: string;
    volume: string;
    netValue: string;
    leverage: string;
    isShort: boolean;
    entryPrice: string;
    closePrice: string;
    pnl: string;
    pnlPercent: string;
    tradePair: TradePair | undefined;
    grossPnl: string;
    feePnl: string;
    grossPnlPercent: string;
    feePnlPercent: string;
};

let initialLoadUp = false;

const useUserTrades = () => {
    const { chainId, account } = useWeb3React();
    const { tradePools } = useTradePools();

    const delayComplete = useDelayLoading();

    // const { decimals } = useTokenDetails(
    //     config.addresses[chainId as EnabledChains[number]]?.collateral
    // );

    const { data, error, mutate } = useSWR(
        account && chainId && tradePools
            ? // && decimals
              [
                  'userTrades',
                  account,
                  chainId,
                  //  decimals,
                  tradePools,
              ]
            : null,
        async (
            _,
            userAddress,
            chainId,
            // decimals,
            tradePools
        ): Promise<UserTrade[]> => {
            verifyChainConfig(chainId);

            // const query = `
            //     traders(
            //         where: {
            //             user: "${userAddress.toLowerCase()}"
            //         }
            //     ) {
            //         trades(
            //             orderBy: timestamp,
            //             orderDirection: desc,
            //             where:{
            //                 timestamp_gt : 1675177200
            //             }
            //         ) {
            //             positionId
            //             type
            //             status
            //             volume
            //             timestamp
            //             tradeIndex
            //             entryPrice
            //             closePrice
            //             entryMargin
            //             PnL
            //             percentagePnL
            //             grossPnL
            //             percentageGrossPnL
            //             borrowFeePnL
            //             fundingFeePnL
            //             totalFeePnL
            //             percentageFeePnL
            //             borrowFee
            //             fundingFee
            //             tradePair {
            //                 id
            //                 collateral {
            //                   decimals
            //                 }
            //             }
            //         }
            //     }
            // `;

            // const data: { traders: Pick<Trader, 'trades'>[] } = await subgraphQuery(
            //     query,
            //     { chainId }
            // );

            // if (!data.traders[0]?.trades) {
            //     return [];
            // }

            return [
                {
                    id: '',
                    action: 'CLOSED',
                    volume: '1233',
                    closePrice: '3211',
                    entryPrice: '3100',
                    isShort: false,
                    leverage: '10',
                    margin: '3000',
                    netValue: '200',
                    tradePair: tradePools[0],
                    pnl: '120',
                    pnlPercent: '12',
                    grossPnl: '23',
                    feePnl: '12',
                    feePnlPercent: '1',
                    grossPnlPercent: '5',
                },
            ];

            // return data.traders[0].trades.map((trade) => {
            //     let leverage = parseUnits('0');

            //     if (!BigNumber.from(trade.entryMargin).isZero()) {
            //         leverage = BigNumber.from(trade.volume)
            //             .mul(parseUnits('1', decimals))
            //             .div(trade.entryMargin);
            //     }

            //     const netValue = BigNumber.from(trade.entryMargin).add(trade.PnL);

            //     const tradePair = tradePools.find(
            //         ({ address }) =>
            //             address.toLowerCase() === trade.tradePair.id.toLowerCase()
            //     );

            //     return {
            //         id: trade.positionId?.split('-')[1] || '',
            //         action: trade.status,
            //         volume: formatUnits(trade.volume, decimals),
            //         closePrice: formatUnits(trade.closePrice, config.priceFeedDecimal),
            //         entryPrice: formatUnits(trade.entryPrice, config.priceFeedDecimal),
            //         isShort: trade.type === 'SHORT',
            //         leverage: formatUnits(leverage, decimals),
            //         margin: formatUnits(trade.entryMargin, decimals),
            //         netValue: formatUnits(netValue, decimals),
            //         tradePair,
            //         pnl: formatUnits(trade.PnL, decimals),
            //         pnlPercent: trade.percentagePnL.toString(),
            //         grossPnl: formatUnits(trade.grossPnL, decimals),
            //         feePnl: formatUnits(trade.totalFeePnL, decimals),
            //         feePnlPercent: trade.percentageFeePnL.toString(),
            //         grossPnlPercent: trade.percentageGrossPnL.toString(),
            //     };
            // });
        },
        { dedupingInterval: 0, refreshInterval: 0 }
    );

    const updateUserTrades = async (
        oldTrades?: UserTrade[] | undefined,
        retryCount = 0
    ) => {
        if (!oldTrades || retryCount > 10) return mutate;

        const newTrades = await mutate();

        if (!newTrades?.length || newTrades.length === oldTrades.length) {
            await sleep(1000);
            updateUserTrades(oldTrades, retryCount + 1);
            return;
        }
    };

    useEffect(() => {
        if (delayComplete) {
            initialLoadUp = true;
        }
    }, [delayComplete]);

    return {
        userTrades: data,
        isLoading: (!data && !error) || (!initialLoadUp && !delayComplete),
        error,
        updateUserTrades,
    };
};

export default useUserTrades;
